
module.directive('fieldLabelSettings', function() {
    return {
        restrict: 'A',
        scope: {useQuestion: '='},
        controller: function($scope) {
            var labels = [];

            this.addLabel = function(handler) {
                labels.push(handler);
                handler(!!$scope.useQuestion);
                return function() {
                    var index = labels.indexOf[handler];
                    if (index >= 0) {
                        labels.splice(index, 1);
                    }
                };
            };

            $scope.$watch('!!useQuestion', function(useQuestion) {
                for (var i = 0; i < labels.length; i++) {
                    labels[i](useQuestion);
                }
            });
        }
    };
});


module.directive('fieldLabel', function(ModelConfig) {
    return {
        restrict: 'E',
        templateUrl: 'util/input/fieldLabel',
        require: '?^fieldLabelSettings',
        scope: {},
        link: function(scope, element, attrs, fieldLabelSettings) {
            var datapointName = attrs.name;
            if (!datapointName) return;

            scope.name = datapointName;
            scope.model = attrs.model;

            function updateLabel(useQuestion) {
                if (useQuestion) {
                    scope.label = ModelConfig.getQuestion(datapointName, scope.model)
                } else {
                    scope.label = ModelConfig.getLabel(datapointName, scope.model)
                }
            }

            if (angular.isDefined(attrs.useQuestion)) {
                attrs.$observe('useQuestion', updateLabel);
            } else if (fieldLabelSettings) {
                fieldLabelSettings.addLabel(updateLabel);
            } else {
                updateLabel(true);
            }
        },
    };
});